(function () {
  var SLOW_MS = 15000;
  var banner;
  var textEl;
  var actionEl;
  var closeEl;
  var dismissedOffline = false;
  var dismissedSlow = false;
  var mode = null;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function ensureBanner() {
    if (banner) return banner;
    banner = qs('#fp-network-banner');
    if (!banner) return null;
    textEl = qs('.fp-network-banner__text', banner);
    actionEl = qs('.fp-network-banner__action', banner);
    closeEl = qs('.fp-network-banner__close', banner);

    if (actionEl) {
      actionEl.addEventListener('click', function () {
        if (mode === 'offline') {
          hideBanner();
          window.location.reload();
          return;
        }
        if (mode === 'slow') {
          hideBanner();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    if (closeEl) {
      closeEl.addEventListener('click', function () {
        if (mode === 'offline') dismissedOffline = true;
        if (mode === 'slow') dismissedSlow = true;
        hideBanner();
      });
    }

    return banner;
  }

  function showBanner(nextMode, message, actionLabel) {
    if (!ensureBanner() || !textEl) return;
    if (nextMode === 'offline' && dismissedOffline) return;
    if (nextMode === 'slow' && dismissedSlow) return;

    mode = nextMode;
    textEl.textContent = message;
    if (actionEl) {
      if (actionLabel) {
        actionEl.hidden = false;
        actionEl.textContent = actionLabel;
      } else {
        actionEl.hidden = true;
      }
    }
    banner.hidden = false;
    requestAnimationFrame(function () {
      banner.classList.add('is-visible');
    });
  }

  function hideBanner() {
    if (!banner) return;
    banner.classList.remove('is-visible');
    mode = null;
    window.setTimeout(function () {
      if (banner && !banner.classList.contains('is-visible')) {
        banner.hidden = true;
      }
    }, 280);
  }

  function syncOfflineState() {
    if (!navigator.onLine) {
      showBanner(
        'offline',
        'Connection lost. Please check your network, then retry to continue shopping.',
        'Retry'
      );
      return;
    }
    if (mode === 'offline') hideBanner();
  }

  function isInteractiveHost(el) {
    if (!el || el.nodeType !== 1) return true;
    var tag = el.tagName;
    return (
      tag === 'A' ||
      tag === 'BUTTON' ||
      tag === 'LABEL' ||
      el.getAttribute('role') === 'link' ||
      el.getAttribute('role') === 'button'
    );
  }

  function getRetryHost(img) {
    var preferred = img.closest(
      '.cpg-image-box, .card__media, .media, .product__media-item, .slideshow .media, .collection-card, .article-card__image-wrapper, .fp-img-shell'
    );
    if (preferred && !isInteractiveHost(preferred)) return preferred;

    var parent = img.parentElement;
    if (parent && !isInteractiveHost(parent)) return parent;

    var shell = img.closest('.fp-img-shell');
    if (shell) return shell;

    shell = document.createElement('span');
    shell.className = 'fp-img-shell';
    parent = img.parentElement;
    if (!parent) return null;
    parent.insertBefore(shell, img);
    shell.appendChild(img);
    return shell;
  }

  function clearFailedHost(img) {
    var host = img.closest('.fp-img-failed-host');
    if (!host) return;
    var retry = host.querySelector(':scope > .fp-img-retry');
    if (retry) retry.remove();
    host.classList.remove('fp-img-failed-host');
  }

  function markLoaded(img) {
    img.classList.remove('fp-img-pending', 'fp-img-failed');
    img.classList.add('fp-img-loaded');
    clearFailedHost(img);
  }

  function markFailed(img) {
    if (!img || img.dataset.fpImgFailed === '1') return;
    // Only fail after a real error, or confirmed broken non-lazy image.
    img.dataset.fpImgFailed = '1';
    img.classList.remove('fp-img-pending', 'fp-img-loaded');
    img.classList.add('fp-img-failed');

    var host = getRetryHost(img);
    if (!host) return;
    host.classList.add('fp-img-failed-host');

    if (host.querySelector(':scope > .fp-img-retry')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fp-img-retry';
    btn.textContent = 'Image failed to load · Tap to retry';
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      retryImage(img);
    });
    host.appendChild(btn);
  }

  function retryImage(img) {
    img.dataset.fpImgFailed = '';
    clearFailedHost(img);
    img.classList.remove('fp-img-failed', 'fp-img-loaded');
    img.classList.add('fp-img-pending');

    var src = img.getAttribute('src');
    var srcset = img.getAttribute('srcset');

    img.addEventListener('load', function onLoad() {
      markLoaded(img);
    }, { once: true });
    img.addEventListener('error', function onError() {
      markFailed(img);
    }, { once: true });

    if (src) {
      img.removeAttribute('src');
      img.src = src;
    }
    if (srcset) {
      img.removeAttribute('srcset');
      img.setAttribute('srcset', srcset);
    }
  }

  function isLazyImage(img) {
    var loading = (img.getAttribute('loading') || '').toLowerCase();
    if (loading === 'lazy') return true;
    if (img.dataset.src || img.dataset.srcset) return true;
    return false;
  }

  function shouldTrack(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.dataset.fpNetUx === '1') return false;
    if (img.closest('noscript')) return false;
    if (img.classList.contains('placeholder-svg')) return false;

    var src = img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset') || '';
    if (!src && !srcset) return false;
    if (src.indexOf('data:') === 0) return false;

    return true;
  }

  function trackImage(img) {
    if (!shouldTrack(img)) return;
    img.dataset.fpNetUx = '1';

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img);
      return;
    }

    // Lazy / not yet requested: wait for load or error. Do NOT treat as failed.
    if (!img.complete || isLazyImage(img) || img.naturalWidth === 0) {
      img.classList.add('fp-img-pending');
      img.addEventListener(
        'load',
        function () {
          markLoaded(img);
        },
        { once: true }
      );
      img.addEventListener(
        'error',
        function () {
          markFailed(img);
        },
        { once: true }
      );
    }
  }

  function scanImages(root) {
    (root || document).querySelectorAll('img').forEach(trackImage);
  }

  function initImageObserver() {
    scanImages(document);

    document.addEventListener(
      'error',
      function (event) {
        var target = event.target;
        if (!target || target.tagName !== 'IMG') return;
        if (target.dataset.fpNetUx !== '1') trackImage(target);
        markFailed(target);
      },
      true
    );

    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') {
            trackImage(node);
            return;
          }
          if (node.querySelectorAll) scanImages(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function connectionLooksSlow() {
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return false;
    if (conn.saveData) return true;
    var type = conn.effectiveType || '';
    return type === 'slow-2g' || type === '2g';
  }

  function hasPendingStoreImages() {
    return Boolean(document.querySelector('img.fp-img-pending'));
  }

  function initSlowHint() {
    if (document.readyState === 'complete') return;

    var timer = window.setTimeout(function () {
      if (document.readyState === 'complete' || !navigator.onLine) return;
      // Avoid noisy false positives on normal overseas broadband.
      if (!connectionLooksSlow() && !hasPendingStoreImages()) return;
      showBanner(
        'slow',
        'Network is slow. Product images may take longer to load.',
        'Back to top'
      );
    }, SLOW_MS);

    window.addEventListener(
      'load',
      function () {
        window.clearTimeout(timer);
        if (mode === 'slow') hideBanner();
      },
      { once: true }
    );
  }

  function init() {
    ensureBanner();
    syncOfflineState();
    window.addEventListener('offline', syncOfflineState);
    window.addEventListener('online', syncOfflineState);
    initImageObserver();
    initSlowHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
